import { render } from "./Catalog.vue?vue&type=template&id=2221af30"
import script from "./Catalog.vue?vue&type=script&lang=js"
export * from "./Catalog.vue?vue&type=script&lang=js"

import "./Catalog.vue?vue&type=style&index=0&id=2221af30&lang=scss"
script.render = render

export default script